import { render, staticRenderFns } from "./faqItems.vue?vue&type=template&id=8a1e30c6"
import script from "./faqItems.vue?vue&type=script&lang=js"
export * from "./faqItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports